module.exports = __webpack_public_path__ + "static/media/MSA.f1cd5369.png";